export const isParticipantOnlyViewer = ({ isHost, isParticipant }) =>
  Boolean(isParticipant) && !Boolean(isHost);

export const canJoinEventSession = ({
  event,
  isHost,
  isParticipant,
  hasConfirmedAttendance,
}) => {
  const viewerCode = String(event?.storage_code || "").trim().toUpperCase();
  const isNewJoinersOrganizer = Boolean(
    event?.is_new_joiners_event && (
      isHost || (viewerCode && (event?.co_hosts || []).some(
        (host) => String(host?.code || "").trim().toUpperCase() === viewerCode
      ))
    )
  );
  return Boolean(
    (event?.is_vaultgrid_party || event?.is_new_joiners_event || event?.is_sport_session_event) &&
    (isParticipant || isHost) &&
    (hasConfirmedAttendance || isNewJoinersOrganizer)
  );
};
